__turbopack_context__.v({
  "button": "card-module__NTI1sW__button",
  "card": "card-module__NTI1sW__card",
  "content": "card-module__NTI1sW__content",
  "image": "card-module__NTI1sW__image",
  "small": "card-module__NTI1sW__small",
  "subtitle": "card-module__NTI1sW__subtitle",
  "text": "card-module__NTI1sW__text",
});
